const mutations = {

    setServiceRequestQuotationList(state, data) {
        state.serviceRequestQuotations = data;
    },
    setQuotationList(state, data) {
        state.quotationList = data.rows;
        state.quotationMeta = data.meta;
    },
    resetQuotation(state){
        state.serviceRequestQuotation = {
            total : null,
            description : null
        }
    },
    setQuotation(state, data) {
        state.serviceRequestQuotation = data;
    },
    resetProductData(state) {
        state.detailedProductData= [
            {
                productId: "",
                name: "",
                quantity: null,
                taxRate: null,
            },
          ];
    },
    resetDetailedLaborCosts(state) {
        state.detailedLaborCosts= [];
    }
}

export default mutations;